
// parse string into parts that can be manipulated, keeping track of extra
// stuff
function parse(s) {
    let parts = [];
    let words = [];
    let wordIdx = [];
    let endIdx = [0];
    for (let match of s.matchAll(/\b[a-zA-Z\-']+\b/g)) {
        words.push(match[0]);
        if (endIdx.slice(-1)[0] < match.index) {
            parts.push(s.substring(endIdx.slice(-1)[0], match.index));
        }
        parts.push(match[0]);
        wordIdx.push(parts.length - 1);
        endIdx.push(match.index + match[0].length);
    }
    if (endIdx.slice(-1)[0] < s.length) {
        parts.push(s.substring(endIdx.slice(-1)[0], s.length));
    }
    return [parts, words, wordIdx];

}

// yields the full current text at each timestep
async function *manipulate(
    pin,
    currentText,
    phonWarp,
    orthWarp,
    temperature) {

    let [parts, words, wordIdx] = parse(currentText);
    console.log(parts, words, wordIdx);
    
    let caseFlattened = words.map((w) => w.toLowerCase());

    let iter = pin.manipulateAsync(caseFlattened, orthWarp, phonWarp, temperature);
    //

    let overwriteWords = words.slice();
    let phonStep = 0;
    let orthStep = 0;
    let stopped = new Array(words.length).fill(false);

    for await (let [desc, val] of iter) {
        //await frame();
        if (desc == 'phon_decoding') {
            for (let i = 0; i < overwriteWords.length; i++) {
                if (phonStep < overwriteWords[i].length) {
                    overwriteWords[i] = overwriteWords[i].substring(0, phonStep) + "▒" + overwriteWords[i].substring(phonStep+1);
                }
            }
            console.log("phon", phonStep, overwriteWords);
            phonStep++;
        }
        if (desc == 'orth_decoding') {
            console.log(desc, val);
            for (let i = 0; i < overwriteWords.length; i++) {
                // match case to original as best as possible!
                let ch = val[i];
                let srcCh = words[i].charAt(orthStep);
                if (srcCh.length > 0 && !["'", "-"].includes(srcCh) && srcCh == srcCh.toUpperCase()) {
                    ch = ch.toUpperCase();
                }
                if (val[i] == '$') {
                    stopped[i] = orthStep;
                }
                if (orthStep < overwriteWords[i].length) {
                    if (val[i] != '$') {
                        overwriteWords[i] = overwriteWords[i].substring(0, orthStep) + ch + overwriteWords[i].substring(orthStep+1);
                    }
                }
                else {
                    if (stopped[i] !== false) {
                        overwriteWords[i] = overwriteWords[i].substring(0, stopped[i]);
                    }
                    else {
                        overwriteWords[i] += ch;
                    }
                }
            }
            orthStep++;
            console.log("orth", orthStep, overwriteWords);
        }
        // recompose text
        
        let partsCopy = parts.slice();
        for (let i = 0; i < wordIdx.length; i++) {
            partsCopy[wordIdx[i]] = overwriteWords[i];
        }
        currentText = partsCopy.join("");
        yield currentText;
    }

    currentText = currentText.replaceAll("▒", "");
    yield currentText;

}

export { parse, manipulate };